import { inject } from 'vue'
import { drawerInjectionKey } from './context'
import type { DrawerProvider } from './types'

function useDrawer() {
  const provider = inject<DrawerProvider>(drawerInjectionKey)

  if (!provider) {
    throw new Error('No outer <DrawerProvider /> founded.')
  }

  return provider
}

export default useDrawer
